import { AxiosPromise } from "axios";
import { request } from "utils/request";

export const voteApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/vote",
      params,
    }),
  summary: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/vote/summary",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/vote",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/vote/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/vote/${id}`,
      method: "delete",
    }),
};
